/*
 *   File : details-preview-card.js
 *   Author : https://evoqins.com
 *   Description : Detail Preview card Component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import PickFundImage from "../../Assets/Images/Home/pick-fund.png";

function DetailPreviewCard(props) {
    return (
        <div className="text-center e-border-1px-white-marble e-border-radius-24 padding-26px-lr padding-32px-tb">
            <img src={PickFundImage}
                alt="pick a fund for detailed analyses"
                draggable="false"
                className='col-8 col-sm-6 col-md-8 col-lg-12 px-3 px-lg-4 px-xl-5 img-fluid margin-32px-bottom' />
            <h6 className='e-text-egyptian-blue e-font-14-res  e-font-18 e-primary-font-inter e-font-weight-600 line-height-24px margin-12px-bottom'>
                {props.title}
            </h6>
            <p className='e-text-dark_liver px-xl-4  e-font-12 -res e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px margin-12px-bottom'>
                {props.description}
            </p>
        </div>
    )
}

export default DetailPreviewCard